import styled from 'styled-components';

import { colors } from 'common/styles/style-constants';
import { Checkbox } from 'opencare-crown';

export const TimePeriodCheckboxes = styled(Checkbox.Group)`
  && {
    margin-bottom: 10px;

    .ant-checkbox + span {
      padding-right: 0;
    }

    .ant-checkbox-group-item {
      width: 50%;
      margin: 0 0 5px;
      font-size: 13px;

      .ant-checkbox-inner {
        border: 1px solid ${colors.darkBlue};
      }

      .ant-checkbox-checked {
        &:after {
          border: none;
        }
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${colors.darkBlue};
      }
    }
  }
`;
